const Udon = () => {
  return (
    <div className="menu-box">
      <h3 className="menu-category">udon</h3>
      <ul className="menu-list">
        <li className="menu-item">
          <p>PLAIN udon</p>
          <p>$10.00</p>
        </li>
        <li className="menu-item">
          <p>Chicken udon</p>
          <p>$12.00</p>
        </li>
        <li className="menu-item">
          <p>Katsu udon</p>
          <p>$12.00</p>
        </li>
        <li className="menu-item">
          <p>Tempura udon</p>
          <p>$12.00</p>
        </li>
        <li className="menu-item">
          <p>Seafood udon</p>
          <p>$12.00</p>
        </li>
      </ul>
    </div>
  );
};

export default Udon;
